import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  sendRequest,
  requestInProcess,
  requestFinished,
  setErrors,
  selectFieldFiles,
  clearAllErrors
} from '../../../../common/reducers/execAddMaterialsReducer';

import { insertUpdateChildItems } from '../../../../../../common/reducers/listsCollection/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksExecsMaterials from '../../../../services/TasksExecsMaterials';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';

function* sendExecMaterials(reducerName, action) {
  const fieldFiles = yield select(selectFieldFiles, reducerName);
  yield put(requestInProcess(reducerName));
  try {
    yield put(clearAllErrors(reducerName));

    const result = yield call(
      timeoutCall,
      TasksExecsMaterials.setNotSendMaterialsByExec,
      action.payload,
      fieldFiles.value
    );
    if (result.response) {
      if (result.response.status === 422) {
        yield put(setErrors(reducerName, result.response.data));
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'danger',
            message: result.response.data[0].message
          })
        );
      } else if (result.response.status === 201) {
        yield put(
          insertUpdateChildItems(
            'tasksModule.collections.tasksExecsNotSendMaterialsCollection',
            {
              itemsById: result.destructData.noSendExecMaterials,
              groupMapItemsIds: result.destructData.noSendExecMaterialsMapByExec
            }
          )
        );
      }
    }
    yield put(
      requestFinished(
        reducerName,
        result.response.status,
        result.response.status === 201
      )
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeEvery(sendRequest(reducerName).type, sendExecMaterials, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/taskExecExecutorForms/saga/execAddMaterialsSaga.js